import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/review/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import FeaturesList from "../components/review/FeaturesList";
import Cta from "../components/review/Cta";
import Testimonials from "../components/review/Testimonials";

const Review = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <FeaturesList />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default Review;
